// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"178":"303c4aa0","377":"7e8a5ee1","539":"6a93c611","932":"463a30a6"}[chunkId] + ".chunk.js";
};